<template>
  <div id="app">
    <nav class="navbar is-dark" role="navigation" aria-label="navigasjon">
      <div class="navbar-brand">
        <a class="navbar-item">
          <img src="@/assets/igive_logo.png">
        </a>
        <a role="button" class="navbar-burger" @click="showNav = !showNav" :class="{ 'is-active': showNav }" aria-label="menu" aria-expanded="false">
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>

      <div class="navbar-menu" :class="{ 'is-active': showNav }">
        <div class="navbar-start">
          <router-link @click="closeMenu()" to="/" class="navbar-item">Hjem</router-link>
        
          <div class="navbar-item has-dropdown is-hoverable" v-if="authenticated">
            <a class="navbar-link">
              Rapporter
            </a>
            <div class="navbar-dropdown">
              <router-link @click.native="closeMenu()" to="/reports/0" class="navbar-item">Gavekortrapport</router-link>
              <router-link @click.native="closeMenu()" to="/reports/6" class="navbar-item">Gavekortrapport - Dagsoppgjør</router-link>
              <router-link @click.native="closeMenu()" to="/reports/5" class="navbar-item">Tilgodekortrapport</router-link>
              <!-- <router-link @click.native="closeMenu()" to="/reports/2" class="navbar-item">Kampanjekortrapport</router-link> -->
              <router-link @click.native="closeMenu()" to="/reports/3" class="navbar-item">Innskudd gavekortbutikk på nett og App</router-link>
              <router-link @click.native="closeMenu()" to="/reports/1" class="navbar-item">Kampanjekortrapport</router-link>
              <router-link @click.native="closeMenu()" to="/reports/4" class="navbar-item" v-if="isSkeidarRema">Skeidar/Rema rapport</router-link>
              <router-link @click.native="closeMenu()" to="/manualtransactions" class="navbar-item">Manuelle transaksjoner</router-link>
            </div>
          </div>
          
          <router-link @click.native="closeMenu()" to="/saldo" class="navbar-item" v-if="authenticated">Månedssaldo</router-link>
          <router-link @click.native="closeMenu()" to="/breakage" class="navbar-item" v-if="authenticated">Breakagerapport</router-link>

          <div class="navbar-item has-dropdown is-hoverable" v-if="isAdmin">
            <a class="navbar-link">
              Administrasjon
            </a>
            <div class="navbar-dropdown">
              <router-link @click.native="closeMenu()" to="/users" class="navbar-item">Brukere</router-link>
              <router-link @click.native="closeMenu()" to="/products" class="navbar-item">Mapping produkter</router-link>
              <router-link @click.native="closeMenu()" to="/mail" class="navbar-item">Rapportutsendelser på epost</router-link>
              <router-link @click.native="closeMenu()" to="/settings" class="navbar-item">Innstillinger</router-link>
              <router-link @click.native="closeMenu()" to="/history" class="navbar-item">Importhistorikk</router-link>
            </div>
          </div>  

        </div>

        <div class="navbar-end">
          <div class="navbar-item">
            <a v-if="!authenticated"  @click.native="closeMenu()" class="button is-primary" @click="login()">Logg inn</a>
            <a v-if="authenticated"  @click.native="closeMenu()" class="button is-danger" @click="logout()">
              <b-icon pack="fa" icon="user"></b-icon>
              <span>Logg ut {{ profile.firstname + ' ' + profile.lastname }}</span>
            </a>
          </div>          
        </div>

      </div>
    </nav>
    
    
      <router-view :key="$route.fullPath"/>
    
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  data () {
    return {
      showCookieWarning: localStorage.getItem('cookieWarningDismissed') === null,
      showNav: false
    }
  },
  methods: {
    ...mapActions('auth', ['login', 'logout']),
    popCookieWarning() {
      this.$buefy.snackbar.open({
        message: 'IGive benytter informasjonskapsler for å berike funksjonalitet på siden, ingen personlig informasjon oppbevares.',
        type: 'is-warning',
        position: 'is-bottom',
        actionText: 'OK',
        indefinite: true,
        onAction: () => {
          localStorage.setItem('cookieWarningDismissed', true)
        }
      })
    },
    closeMenu () {
      this.showNav = false
    }
  },
  computed: mapGetters('auth', ['authenticated', 'profile', 'isAdmin', 'isSkeidarRema', 'passwordChangeRequired']),
  mounted () {
    if (this.showCookieWarning)
      this.popCookieWarning()
  }
}
</script>


<style lang="scss">
@import '~bulma-divider';

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

div.container {
  @media (min-width: 250px) and (max-width: 1024px) {
    margin: 0px 8px 0px 8px
  }
}

a.navbar-burger, a.navbar-burger:hover {
  color: #fff;
}

.main.container {
  margin-top: 32px;
}

.router-link-active{
  font-weight:bold;
}

.navbar-item.has-dropdown.is-hoverable:hover .navbar-dropdown {
  display: block !important;
}

</style>
